import { Hub } from "aws-amplify/utils";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useGetAuthUser } from "@/api/get-user";

export function UnauthenticatedGuard({
  children,
}: {
  children: React.ReactElement;
}) {
  const navigate = useNavigate();
  const { refetch: refetchUser, isSuccess, isLoading } = useGetAuthUser();

  useEffect(() => {
    if (isSuccess && !isLoading) {
      navigate("/");
    }
  }, [isSuccess, isLoading, navigate]);

  function listenAuthChange(): () => void {
    const listener = Hub.listen("auth", async (data) => {
      const searchParams = new URLSearchParams(location.search);
      const redirectUrl = searchParams.get("redirect") || "/";

      switch (data.payload.event) {
        case "signedIn":
          await refetchUser();
          navigate(redirectUrl);
          break;
      }
    });

    return listener;
  }

  useEffect(() => {
    const listener = listenAuthChange();

    return () => listener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
}
